import { h, Fragment, Component } from "preact"
import { Endpoint } from "../util/endpoint"
import { qs } from "../util/dom"

import { PlacesApp } from "./farmers/places-app"
import { FarmersApp } from "./farmers/farmers-app"
import { Modal } from "./farmers/modal"

/**
 * FARMERS AND PLACES
 */

const detailData = { farmers: [], locations: [], partners: [] }

export class FarmersAndPlaces extends Component {
  endpoints = {
    markers: new Endpoint(this.props.root.dataset.endpointMarkers),
    farmers: new Endpoint(this.props.root.dataset.endpointFarmers),
    locations: new Endpoint(this.props.root.dataset.endpointLocations),
    partners: new Endpoint(this.props.root.dataset.endpointPartners),
  }

  breakpoint = ""

  /** Deeplinking */
  checkLocation = (set = false) => {
    const [type, id] = window.location.hash.replace("#", "").split("-")
    if (type && id) {
      if (!set) {
        return { id: Number(id), type }
      }
      this.setState({ activeId: Number(id), activeType: type })
    }
  }

  updateLocation = (id, type) => {
    if (id && type) {
      window.location.hash = `${type}-${id}`
    }
  }

  state = {
    data: false,
    showModal: false,
    activeId: this.checkLocation()?.id,
    activeType: this.checkLocation()?.type,
    loading: true,
    modalData: false,
  }

  componentDidMount() {
    this.getInitialData()

    // window.addEventListener(
    //   "hashchange",
    //   () => {
    //     this.checkLocation(true)
    //   },
    //   false
    // )
  }

  getInitialData = async () => {
    const newdata = await this.endpoints.markers.getData()
    this.setState({ data: newdata })
    setTimeout(() => {
      this.setState({ loading: false })
    }, 1000)
  }

  getDetailData = async (id, type) => {
    let data = detailData[type].find((o) => o.id === id)
    if (!data) {
      data = await this.endpoints[type].getData("", `${id}`)
      detailData[type].push(data)
    }
    return data
  }

  openModalFunction = (activeId, activeType) => {
    this.setState({ showModal: false, modalData: false })
    this.getDetailData(activeId, activeType).then((_data) =>
      this.setState({ modalData: _data }),
    )
    this.updateLocation(activeId, activeType)
    this.setState({ showModal: true, activeId, activeType })
  }

  hideLoader = () => {
    const loader = qs("#farmers-loader")
    loader && (loader.style.display = "none")
  }

  render(_, state) {
    return (
      <>
        <link
          href="//maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"
          rel="stylesheet"
          type="text/css"
        />
        {!state.loading && this.hideLoader()}
        {!state.loading && (
          <PlacesApp
            {...state.data}
            openModalFunction={this.openModalFunction}
            getDetailData={this.getDetailData}
            activeOverride={{ id: state.activeId, type: state.activeType }}
          >
            {state.showModal &&
              ["locations", "partners"].includes(state.activeType) && (
                <Modal
                  translations={state.data.translations}
                  data={state.modalData}
                  closeFunction={() => {
                    this.setState({ showModal: false })
                  }}
                  id={state.activeId}
                  type={state.activeType}
                />
              )}
          </PlacesApp>
        )}
        {!state.loading && (
          <div class="columns">
            <div class="separator-container">
              <div class="separator" />
            </div>
          </div>
        )}
        {!state.loading && (
          <FarmersApp
            {...state.data}
            openModalFunction={this.openModalFunction}
            getDetailData={this.getDetailData}
            activeOverride={{ id: state.activeId, type: state.activeType }}
          >
            {state.showModal && state.activeType === "farmers" && (
              <Modal
                translations={state.data.translations}
                data={state.modalData}
                closeFunction={() => {
                  this.setState({ showModal: false })
                }}
                id={state.activeId}
                type={state.activeType}
              />
            )}
          </FarmersApp>
        )}
      </>
    )
  }
}
